import 'isomorphic-fetch'
import cookies from 'react-cookie'
import { urls } from 'settings'
import types from './actionTypes'

const finishRegistration = (dispatch, payload) => {
  const csrftoken = cookies.load('csrftoken')
  const body = {
    user: {
      first_name: payload.firstName,
      last_name: payload.lastName,
      email: payload.email,
      password: payload.password,
      cellphone: payload.cellphone,
    },
    company_name: payload.companyName,
    country: payload.country,
    city: payload.city,
  }
  return fetch(urls.signup.publisherListUrl(), {
    method: 'POST',
    credentials: 'same-origin',
    headers: new Headers({
      'Content-Type': 'application/json',
      'X-CSRFToken': csrftoken,
    }),
    body: JSON.stringify(body)
  })
    .then(response => {
      if(response.status === 201) {
        dispatch({ type: types.REGISTRATION_SAVED })
        return null
      } else if (response.status === 400) {
        dispatch({ type: types.REGISTRATION_FAILED })
        return response.json()
      } else {
        dispatch({ type: types.REGISTRATION_FAILED })
        return { nonFieldError: 'Unknown error' }
      }
    })
}

export {
  finishRegistration,
}
